const getOffsetTop = (element) => {
  const firstChildOfBody = document.getElementsByTagName('body')[0];
  let currentEl = element;
  let offsetTop = currentEl.offsetTop;

  while (currentEl.offsetParent && currentEl !== firstChildOfBody) {
    offsetTop += currentEl.offsetParent.offsetTop;
    currentEl = currentEl.offsetParent;
  }

  return offsetTop;
};

const scrollViewTo = ({ id, offset, el, behavior = 'auto' }) => {
  const element = el || document.getElementById(id);
  if (element) {
    window.scrollTo({ left: 0, top: getOffsetTop(element) - (offset || 0), behavior });
  }
};

export default scrollViewTo;

export function isElementInViewport(element) {
  const coordinates = element.getBoundingClientRect();
  return (
    coordinates.top >= 0
    && coordinates.left >= 0
    && coordinates.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    && coordinates.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}



// WEBPACK FOOTER //
// ./src/util/scrollViewTo.js